/* istanbul ignore file */
import { array as codecArray, number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CourseSectionParser = /* #__PURE__ */ parsers.object([
    ['id', codecString],
    ['name', codecString],
    ['courseId', codecNumber, 'course_id'],
    ['memberCount', /* #__PURE__ */ parsers.maybeNull(codecNumber), 'member_count'],
    [
        'memberIds',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ codecArray(codecNumber)),
        'member_ids',
    ],
]);
export class CourseSection extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseSectionParser.decode(input).map(res => new CourseSection(res));
    }
    static unsafeDecode(input) {
        return CourseSection.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseSectionParser.encode(data);
    }
    static schema() {
        return CourseSectionParser.schema();
    }
}
